/**
 * API utility for submitting connect enquiries
 */

const headers = {
  "Content-Type": "application/json",
  "x-internal-client": "DIGITAL_PROFILE",
  "x-channel": "CONTRACTOR_WEB",
};

export async function submitConnectEnquiry(data) {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || process.env.BASE_URL;

  if (!baseUrl) {
    throw new Error("BASE_URL is not configured");
  }

  const payload = data;
  // console.log("payload", payload);

  const response = await fetch(`/v1/api/lead-gen`, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage =
      errorData?.error?.message ||
      errorData?.message ||
      `HTTP ${response.status}: ${response.statusText}`;

    // Create error with status code for better handling
    const error = new Error(errorMessage);
    error.status = response.status;
    error.data = errorData;
    throw error;
  }

  return await response.json();
}
